import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-help-text2.js';

const FileInput = /*@__PURE__*/ proxyCustomElement(class FileInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.fileSelected = createEvent(this, "fileSelected", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.changeHandler = () => {
            const inputFileList = this.fileInput.files;
            if (inputFileList) {
                this.fileSelected.emit({
                    fileList: inputFileList,
                    document_type: this.documentType
                });
            }
        };
        this.files = undefined;
        this.fileString = undefined;
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.multiple = undefined;
        this.documentType = undefined;
        this.inputHandler = undefined;
        this.disabled = undefined;
    }
    componentDidLoad() {
        this.fileInput = this.el.querySelector('input');
    }
    render() {
        return (h(Host, { key: 'ed29128c1c4c811aa030697347adb88e0143b031', exportparts: "label,input,input-invalid" }, h("div", { key: '6c924bdbbccae8e98a382a92e54c5b9c288de8d4', class: "form-group d-flex flex-column" }, h("label", { key: 'dbacccea94e39815737683495e3df83b514b79af', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("input", { key: 'a7eef53c9fff54eace8c6960b8c62a833d30bfa3', ref: (el) => this.fileInput = el, type: "file", name: this.name, part: `input ${this.errorText ? 'input-invalid ' : ''}${this.disabled ? ' input-disabled' : ''}`, class: this.errorText ? 'form-control is-invalid' : 'form-control', multiple: this.multiple, disabled: this.disabled, onChange: this.changeHandler, onInput: this.handleFormControlInput, onBlur: () => this.formControlBlur.emit() }), h("form-control-help-text", { key: 'a5abacb92bdb3fb59d0a2265114e858540f2c4b7', helpText: this.helpText, name: this.name }), h("form-control-error-text", { key: '6eeeef347237d363d3bc6616d58f19a7f0be7e3c', errorText: this.errorText, name: this.name }))));
    }
    get el() { return this; }
}, [0, "form-control-file", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "multiple": [4],
        "documentType": [1, "document-type"],
        "inputHandler": [16],
        "disabled": [4],
        "files": [32],
        "fileString": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-file", "form-control-error-text", "form-control-help-text"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-file":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, FileInput);
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { FileInput as F, defineCustomElement as d };
